import { render } from "./AttendanceAutoConfirm.vue?vue&type=template&id=22f21f25&scoped=true"
import script from "./AttendanceAutoConfirm.vue?vue&type=script&lang=js"
export * from "./AttendanceAutoConfirm.vue?vue&type=script&lang=js"

import "./AttendanceAutoConfirm.vue?vue&type=style&index=0&id=22f21f25&scoped=true&lang=css"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f21f25"]])

export default __exports__